import { render, staticRenderFns } from "./myApp.vue?vue&type=template&id=4e42df40&scoped=true&"
import script from "./myApp.vue?vue&type=script&lang=ts&"
export * from "./myApp.vue?vue&type=script&lang=ts&"
import style0 from "./myApp.vue?vue&type=style&index=0&id=4e42df40&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e42df40",
  null
  
)

export default component.exports